










import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";

import {
  pagination,
  loadingCatch,
  loading,
  SearchbarControl,
  IsMore
} from "@root/lib/decorator";

import ImportPage from "./view/index.vue";

const root = namespace("root");

@Component({
  components: { ImportPage }
})
@SearchbarControl()
export default class ImportIndex extends Vue {
  @root.Action getSystemValue;
  private defaultOrgDisabled = true;
  private urlTemplate = "";

  async getUrl() {
    const { valueValue } = await this.getSystemValue({
      valueCode: "TEMPLATE_URL"
    });
    this.urlTemplate = valueValue;
  }

  created() {
    this.$i18n.locale = "zh-cn";
    this.getUrl();
  }
}
